import React, { useState } from "react";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ImageIcon from '@mui/icons-material/Image';
import AudiotrackIcon from '@mui/icons-material/Audiotrack';
import MovieIcon from '@mui/icons-material/Movie';
import ArchiveIcon from '@mui/icons-material/Archive';
import DownloadIcon from '@mui/icons-material/Download';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import IconButton from '@mui/material/IconButton';

const getFileIcon = (fileName) => {
    const ext = fileName.split('.').pop().toLowerCase();
    const iconProps = { style: { color: '#607d8b', fontSize: 18 } };
    if (['pdf'].includes(ext)) return <PictureAsPdfIcon {...iconProps} style={{ ...iconProps.style, color: '#d32f2f' }} />;
    if (['doc', 'docx'].includes(ext)) return <DescriptionIcon {...iconProps} style={{ ...iconProps.style, color: '#1976d2' }} />;
    if (['xls', 'xlsx'].includes(ext)) return <DescriptionIcon {...iconProps} style={{ ...iconProps.style, color: '#388e3c' }} />;
    if (['zip', 'rar'].includes(ext)) return <ArchiveIcon {...iconProps} style={{ ...iconProps.style, color: '#f57c00' }} />;
    if (['jpg', 'jpeg', 'png', 'gif', 'heic'].includes(ext)) return <ImageIcon {...iconProps} style={{ ...iconProps.style, color: '#7b1fa2' }} />;
    if (['mp3', 'wav'].includes(ext)) return <AudiotrackIcon {...iconProps} style={{ ...iconProps.style, color: '#00796b' }} />;
    if (['mp4', 'mov'].includes(ext)) return <MovieIcon {...iconProps} style={{ ...iconProps.style, color: '#5d4037' }} />;
    return <InsertDriveFileIcon {...iconProps} />;
};

export const DocumentPlayer = ({ url, fileName = 'فایل', caption }) => {
    const [downloadUrl, setDownloadUrl] = useState(null);
    const [progress, setProgress] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [hasStarted, setHasStarted] = useState(false);

    const handleDownload = () => {
        setIsLoading(true);
        setHasStarted(true);
        const controller = new AbortController();

        fetch(url, { signal: controller.signal })
            .then(async (res) => {
                const contentType = res.headers.get("Content-Type") || "application/octet-stream";
                const contentLength = +res.headers.get("Content-Length") || 0;

                const reader = res.body.getReader();
                const chunks = [];
                let received = 0;

                while (true) {
                    const { done, value } = await reader.read();
                    if (done) break;
                    chunks.push(value);
                    received += value.length;
                    if (contentLength > 0) {
                        setProgress(Math.floor((received / contentLength) * 100));
                    }
                }

                const blob = new Blob(chunks, { type: contentType });
                const blobUrl = URL.createObjectURL(blob);
                setDownloadUrl(blobUrl);
                setIsLoading(false);
            })
            .catch((err) => {
                if (err.name !== 'AbortError') console.error("Document fetch failed", err);
                setIsLoading(false);
            });
    };

    const icon = getFileIcon(fileName);

    return (
        <div style={{
            backgroundColor: '#f1f1f1',
            borderRadius: 16,
            padding: '12px 14px',
            fontFamily: 'IRANSans',
            fontSize: 14,
            direction: 'rtl',
            maxWidth: '100%',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row-reverse',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}>
            <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexDirection: 'row-reverse' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1, overflow: 'hidden' }}>
                        <div style={{ fontWeight: 500, color: '#333', fontSize: 15, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{fileName}</div>

                        <div style={{
                            width: 24,
                            height: 24,
                            borderRadius: 12,
                            backgroundColor: '#fff',
                            border: '1px solid #ccc',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0
                        }}>
                            {icon}
                        </div>
                    </div>

                    {!hasStarted && (
                        <IconButton
                            onClick={handleDownload}
                            style={{ backgroundColor: '#1976d2', color: '#fff', width: 36, height: 36 }}
                            size="large">
                            <DownloadIcon fontSize="small" />
                        </IconButton>
                    )}
                    {downloadUrl && (
                        <IconButton
                            component="a"
                            href={downloadUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ backgroundColor: '#4CAF50', color: '#fff', width: 36, height: 36 }}
                            size="large">
                            <OpenInNewIcon fontSize="small" />
                        </IconButton>
                    )}
                </div>
                {caption && <div style={{ fontSize: 13, color: '#666', marginTop: 4 }}>{caption}</div>}
                {isLoading && (
                    <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>
                        در حال دانلود... {progress}%
                    </div>
                )}
            </div>
        </div>
    );
};
